// extracted by mini-css-extract-plugin
module.exports = {"root":"PageSpinner_root__cGXs_","fullPage":"PageSpinner_fullPage__3ojCq"};